import { createSlice } from '@reduxjs/toolkit';

const caseContactsSlice = createSlice({
  name: 'caseContacts',
  initialState: {
    contacts: [],
    contactsCount: null,
    editContact: {},
    caseContactsSuccess: false
  },
  reducers: {
    fetchCasesContactsList(state, action) { 
      state.contacts = action.payload;
    },
    fetchCaseContactsEdit(state, action) { 
      state.editContact = action.payload;
    },
    fetchCaseContactCount(state, action) { 
      state.contactsCount = action.payload;
    },
    addUpdateCaseContactsSuccess(state, action) { 
      state.caseContactsSuccess = action.payload;
    },
  },
});

export const {fetchCasesContactsList, addUpdateCaseContactsSuccess, fetchCaseContactsEdit, fetchCaseContactCount} = caseContactsSlice.actions;

export default caseContactsSlice.reducer;